import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {extraAtomFields} from '@packages/shared/constants/Atoms';
import {withSystem, Plugins, Atom, Types} from '@packages/systems/wfdl';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const FormFileUploadRemoveLink = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    const updatedClasses = classes.push('w-file-remove-link');
    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Link',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Link')),
  },
  showEmpty: true,
  render: FormFileUploadRemoveLink,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          'aria-label': withSystem(
            {defaultValue: 'Remove file', isLocalizable: true},
            TText
          ),
          role: withSystem({defaultValue: 'button'}, TText),
          tabIndex: withSystem({defaultValue: '0'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
});

export default config;
